import { Badge } from '@zarya/ui';
import { t } from '@app/i18n';
import { dataHour } from '@app/format';
import { chipLabel, chipTone, type AdmissionSummary } from './SiteAdmissionModel';

/**
 * O chip da coluna «Admissão» e da página (protótipo §1). Ele lê só o que o último contato gravou: a lista não
 * sonda o cluster. No «Sem resposta», o código do erro vai na dica, sem tradução, como na coluna «Saúde».
 */
export function AdmissionChip({ summary }: { summary?: AdmissionSummary }) {
  const when = dataHour(summary?.error_at);
  const label = chipLabel(summary, when);
  const tip =
    summary?.chip === 'no_response' && summary.error_code
      ? t('sites.admission.chip.noResponse.tip', { code: summary.error_code })
      : undefined;
  return (
    <span data-testid="admission-chip" data-chip={summary?.chip ?? 'not_registered'}>
      <Badge tone={chipTone(summary?.chip ?? 'not_registered')} tip={tip}>
        {label}
      </Badge>
    </span>
  );
}
